import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import useEscKey from "ubs-framework/v2/hooks/useEscKey";
import useResizeHeight from "ubs-framework/v2/hooks/useResizeHeight";
import * as Icon from 'ubs-icons';
import {COLOR} from "../../constant";

const SideModal = React.memo((props) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEscKey(() => {
        if (props?.open && !document.querySelector('.react-datepicker-popper')) props.onClose();
    });

    const scrollHeight = useResizeHeight(['u_side-modal-header', 'u_side-modal-footer']);

    useEffect(() => {
        setTimeout(() => setOpen(true), 10);
    }, [props?.open])

    const handleClose = () => {
        setTimeout(() => setOpen(false), 10);
        props.onClose()
    };
    const overlayClick = () => {
        if (props.outerClick) handleClose()
    }

    return (
        <React.Fragment>
            <div
                ref={ref}
                className={`u_side-modal ${open ? 'active' : ''} ${props?.className ? props?.className : ''}`}
            >
                {/* Modal Overlay */}
                {open && <div className="u_modal-overlay"/>}

                {/* Modal Content */}
                <div className="u_side-modal-layout" style={{maxWidth: `${props.maxWidth}px`}}>

                    {/* top: `${scrollHeightHeader}px`, maxHeight: `calc(100vh - ${scrollHeightHeader}px)` */}

                    {/* Modal header */}
                    <div className="u_side-modal-header u_flex u_align-center u_content-between" id="u_side-modal-header">
                        <div className="u_task-header-left">
                            {
                                props?.header ?
                                    props?.header
                                    :
                                    <h6 className="u_one-line u_task-darkname">{props.name}</h6>
                            }
                        </div>

                        <div className="u_task-header-right u_flex u_align-center">
                            {/*Employee-Icon-Added*/}
                            {props.employeeIcon}

                            {/*Leave-Accrual-Details-Icon-Added*/}
                            {props.accrualDetailsIcon}

                            {/*Leave-Status-Icon-Added*/}
                            {props.leaveStatusIcon}

                            {/*Leave-User-Report-Icon-Added*/}
                            {props.userDetailsIcon}
                            <div className="u_cp u_color-blue u_blue-bgicon" onClick={handleClose}>
                                <Icon.Close size={14} fill={COLOR.u_blue}/>
                            </div>
                        </div>
                    </div>

                    {/* Modal body */}
                    <div className={`u_side-modal-body ${props.className}`} id="u_side-modal-body" style={{maxHeight: `calc(840px - ${scrollHeight}px)`}}>
                        {props.children}
                    </div>

                    {/* Modal footer */}
                    <div className="u_side-modal-footer" id="u_side-modal-footer">
                        {props.footer}
                    </div>

                </div>
            </div>
        </React.Fragment>
    );
})

SideModal.propTypes = {
    open: PropTypes.bool,
    name: PropTypes.string.isRequired,
    maxWidth: PropTypes.number,
    onClose: PropTypes.func.isRequired,
    footer: PropTypes.element,
    headerOptions: PropTypes.element,
    outerClick: PropTypes.bool
};

SideModal.defaultProps = {
    outerClick: true,
};

export default SideModal;
